// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__1CvVj","Title":"Contact_Title__3Hn0d","Body":"Contact_Body__-2d1g"};